var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 4.15071V4.14286M6.5 1H1V6.5L5.94214 11.4421C6.68071 12.1807 7.89071 12.1807 8.62929 11.4421L11.4421 8.62929C12.1807 7.89071 12.1807 6.68071 11.4421 5.94214L6.5 1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2144 1L16.1644 5.95C16.3402 6.12519 16.4796 6.33336 16.5748 6.56257C16.67 6.79178 16.719 7.03753 16.719 7.28571C16.719 7.5339 16.67 7.77965 16.5748 8.00886C16.4796 8.23807 16.3402 8.44624 16.1644 8.62143L12.7858 12",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.bf291077ff2ac01e9f712a1d9dcc8e80.svg";
export { ForwardRef as ReactComponent };